import type { ReactNode } from "react";
import { Link } from "wouter";
import type { ProcessRow } from "@shared/recordSummary";
import { cn } from "@/lib/utils";
import { RecordPanel } from "./RecordFrame";
import { dayLabel, localYmd } from "./recordFormat";

/** Every client tracker the buyer is on, furthest milestone first-class. */
export function ProcessesPanel({ rows, title, bids }: { rows: ProcessRow[]; title: string; bids?: Map<string, ReactNode> }) {
  const today = localYmd(new Date());
  return (
    <RecordPanel title={title} count={rows.length}>
      {rows.length === 0 ? (
        <p className="text-[12.5px] text-muted-foreground">Not on any client's buyer tracker yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-[12.5px]">
            <thead>
              <tr className="border-b text-left text-[10.5px] uppercase tracking-wider text-muted-foreground">
                <th className="px-2 py-1 font-semibold">Project</th>
                <th className="px-2 py-1 font-semibold">Client</th>
                <th className="px-2 py-1 font-semibold">Furthest</th>
                <th className="px-2 py-1 font-semibold">Reached</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.clientId} className={cn("border-b last:border-0", !r.active && "text-muted-foreground")}>
                  <td className="px-2 py-1.5 font-semibold">{r.projectName ?? <span className="text-muted-foreground">—</span>}</td>
                  <td className="px-2 py-1.5"><Link href={`/clients/${r.clientId}`} className="hover:underline">{r.clientName}</Link>{!r.active && " (past)"}</td>
                  <td className="px-2 py-1.5">
                    <span className={cn("rounded px-1.5 py-px text-[11px] font-semibold", r.active && (r.furthest === "LOI" || r.furthest === "IOI") ? "bg-primary/15 text-primary-text" : "bg-muted")}>
                      {r.furthest ?? "Added"}
                    </span>
                    {bids?.get(r.clientId)}
                  </td>
                  <td className="whitespace-nowrap px-2 py-1.5 tabular-nums">{dayLabel(r.furthestOn, today)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </RecordPanel>
  );
}
